import { MinzeElement } from 'minze'

export interface LvcCopyIcon {}

export class LvcCopyIcon extends MinzeElement {
  html = () => `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1428 6.42857H8.71422C7.92524 6.42857 7.28564 7.06817 7.28564 7.85715V14.2857C7.28564 15.0747 7.92524 15.7143 8.71422 15.7143H15.1428C15.9318 15.7143 16.5714 15.0747 16.5714 14.2857V7.85715C16.5714 7.06817 15.9318 6.42857 15.1428 6.42857Z" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.4285 10.7143H3.71422C3.33534 10.7143 2.97197 10.5638 2.70406 10.2959C2.43615 10.028 2.28564 9.6646 2.28564 9.28572V2.85715C2.28564 2.47826 2.43615 2.1149 2.70406 1.84699C2.97197 1.57908 3.33534 1.42857 3.71422 1.42857H10.1428C10.5217 1.42857 10.885 1.57908 11.1529 1.84699C11.4208 2.1149 11.5714 2.47826 11.5714 2.85715V3.57143" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `

  css = () => `
    
  `
}
